import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const ROUTE_LABELS = {
  '/': 'Dashboard',
  '/strategy': 'Strategy Hub',
  '/releases': 'Releases',
  '/users': 'User Management',
  '/metadata': 'Metadata',
  '/sync': 'Integrations',
  '/profile': 'Profile',
};

export function Breadcrumbs({ items }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Auto-generate breadcrumbs from current path if not provided
  const crumbs = items || generateBreadcrumbs(location.pathname);

  if (!crumbs || crumbs.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm" data-testid="breadcrumbs">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <React.Fragment key={crumb.path || index}>
            {index > 0 && (
              <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50 shrink-0" />
            )}
            {isLast ? (
              <span
                className="text-foreground font-medium truncate max-w-[200px]"
                data-testid={`breadcrumb-current`}
              >
                {crumb.label}
              </span>
            ) : (
              <button
                onClick={() => navigate(crumb.path)}
                className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5 truncate max-w-[160px]"
                data-testid={`breadcrumb-${crumb.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {index === 0 && <Home className="h-3.5 w-3.5 shrink-0" />}
                <span className="hidden sm:inline">{crumb.label}</span>
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

function generateBreadcrumbs(pathname) {
  const crumbs = [{ label: 'Dashboard', path: '/' }];

  if (pathname === '/') return crumbs;

  // Direct route match
  if (ROUTE_LABELS[pathname]) {
    crumbs.push({ label: ROUTE_LABELS[pathname], path: pathname });
    return crumbs;
  }

  // Dynamic routes like /roadmap/:id
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] === 'roadmap' && segments[1]) {
    crumbs.push({ label: 'Roadmap', path: pathname });
  }

  return crumbs;
}

export default Breadcrumbs;
